import type { Mapper } from '@/core/mapper/base-mapper';
import type { GetBeraJobSummariesResponseDTO } from '@/core/dto/bera';
import type { BeraJobSummaryListItem, BeraJobSummaryListPage } from '@/types/Bera';

export class GetBeraJobSummariesMapper implements Mapper<BeraJobSummaryListPage> {
	constructor(private readonly data: GetBeraJobSummariesResponseDTO) {}

	toDomain(): BeraJobSummaryListPage {
		const rows = this.data.rows.map(GetBeraJobSummariesMapper.toItem);
		const result: BeraJobSummaryListPage = {
			count: this.data.count,
			rows
		};
		return result;
	}

	private static toItem(row: GetBeraJobSummariesResponseDTO['rows'][number]): BeraJobSummaryListItem {
		const item: BeraJobSummaryListItem = {
			id: row.id,
			version: row.version,
			report_name: row.report_name,
			cycle_name: row.cycle_name ?? null,
			workstation_name: row.workstation_name ?? null,
			tlid_count: row.bera_report.length,
			overall_score: row.overall_score,
			updated_at: row.updated_at,
			versions_count: row.versions_count,
			consolidated: row.consolidated
		};
		return item;
	}
}
